import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=3a31a857&"
import script from "./Select.vue?vue&type=script&lang=ts&"
export * from "./Select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sush/Virtual/cublic-form-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a31a857')) {
      api.createRecord('3a31a857', component.options)
    } else {
      api.reload('3a31a857', component.options)
    }
    module.hot.accept("./Select.vue?vue&type=template&id=3a31a857&", function () {
      api.rerender('3a31a857', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resource/component/form/Field/Select.vue"
export default component.exports